import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import Cookies from "js-cookie";
import { AffiliateTrackerInterface, AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { WebservicesService } from '../webservices/webservices.service';


@Injectable({
    providedIn: 'root'
  })
export class IncomeAccessTracker implements AffiliateTrackerInterface {
    protected configVars: any;
    protected params: any;
    private attributionData: any = null;
    
    constructor(
        private webservices: WebservicesService,
    ) {  
    }
    
    initialize(): Promise<AffiliateTrackerInterface> {      
        return Promise.resolve( this);
    }

    captureParameters(): Array<string> {
        return [ 'btag'];
    }
    
    setAttributionData( attr_data: any): void {
        console.log( 'incomeaccess-tracker.ts: setAttributionData: ', attr_data);
        this.attributionData = attr_data;
    }
    
    protected eventtrackingRegistration( customer_id: number|string)
    {
        let args:any = {
            'Playerid': customer_id,
        };
        if( this.attributionData && "undefined" !== typeof this.attributionData.btag) {
            args.BTag = this.attributionData.btag;
        }
        this.webservices.post( 'external/incomeaccess-event-registration', args
            ).subscribe( (data) => {
                console.log( 'incomeaccess-tracker.ts: data:', data);
            }, (err) => {
                console.log( 'incomeaccess-tracker.ts: err:', err);
            });

    }
    
    public signupComplete( cbParams: AffiliateTrackerCallbackParams)
    {
        this.eventtrackingRegistration( cbParams.customer_id);
    }
    public signupStep1Complete( cbParams: AffiliateTrackerCallbackParams)
    {
        this.eventtrackingRegistration( cbParams.customer_id);
    }
        
}    